import * as actions from 'app/actions/driver';
import http from 'app/services/http';

export const driverReducer = (
    state = {
        items: [],
        searchValue: '',
        selectedItem: null,
    },
    action
) => {
    switch (action.type) {
        case 'DRIVER_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                items: items,
            };
        }
        case 'DRIVER_SET_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                selectedItem: data,
            };
        }
        case 'DRIVER_SET_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                searchValue: value,
            };
        }
        case 'DRIVER_ADD_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                items: [...state.items, data],
            };
        }
        case 'DRIVER_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                selectedItem: data,
                items: state.items.map((item) => (item.id !== state.selectedItem.id ? item : data)),
            };
        }
        case 'DRIVER_DELETE_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                items: state.items.filter((item) => item.id !== id),
                selectedItem: null,
            };
        }
        default:
            return state;
    }
};

export function driverLoad() {
    return async function driverLoadThunk(dispatch) {
        const { data } = await http.get('/driver');
        return dispatch(actions.setItems(data));
    };
}

export function driverCreate(params) {
    return async function driverCreateThunk(dispatch) {
        const { data } = await http.post('/driver', params);
        return dispatch(actions.addItem(data));
    };
}

export function driverUpdate(id, updateData) {
    return async function driverUpdateThunk(dispatch) {
        const { data } = await http.put(`/driver/${id}`, updateData);
        return dispatch(actions.updateItem(data));
    };
}

export function driverDelete(id) {
    return async function driverDeleteThunk(dispatch) {
        await http.delete(`/driver/${id}`);
        return dispatch(actions.deleteItem(id));
    };
}

export default driverReducer;
